import "./statusModal.scss";
import { isDefined } from "@timeedit/registration-shared";
import { SeverityIcon } from "../SeverityIcons";
import { CapitalizedNoticeType } from "../../hooks/types";
import { Modal, ModalProps } from "@timeedit/ui-components";

type StatusModalTitleProps = {
  title: string;
  severity: CapitalizedNoticeType;
};
function StatusModalTitle({
  severity,
  title,
}: StatusModalTitleProps): React.JSX.Element {
  return (
    <div className="status-modal-title__container">
      <SeverityIcon type={severity} />
      {title}
    </div>
  );
}

type StatusModalProps = {
  title: string;
  text?: React.JSX.Element;
  severity?: CapitalizedNoticeType;
} & ModalProps;
export function StatusModal(props: StatusModalProps): React.JSX.Element {
  const title = isDefined(props.severity) ? (
    <StatusModalTitle severity={props.severity} title={props.title} />
  ) : (
    props.title
  );
  const className = isDefined(props.severity)
    ? "status-modal-text__container"
    : "";
  return (
    <Modal {...props} title={title}>
      <div className={className}>{props.text}</div>
    </Modal>
  );
}
